import React from 'react';

import { TableCell, TableRow } from '@material-ui/core';

import { ArrowDown } from '../../../components/ArrowDown/ArrowDown';
import { ArrowUp } from '../../../components/ArrowUp/ArrowUp';
import { IClubTransaction } from '../../../store/admin/clubs/store';
import { getFormattedTransactionData } from './Utils/getFormattedTransactionData';

interface ITransactionRow {
  transaction: IClubTransaction;
  index: number;
  collapsedRow: number;
  setCollapsedRow: any;
}

export const TransactionRow = (props: ITransactionRow) => {
  const { transaction, index, collapsedRow, setCollapsedRow } = props;

  const isCollapsed = collapsedRow === index;

  const {
    eventName,
    formattedAmount,
    formattedDate,
    payeer,
    paymentMethod,
    type
  } = getFormattedTransactionData(transaction);

  return (
    <TableRow className="transaction-row">
      <TableCell>{formattedDate}</TableCell>
      <TableCell>{eventName}</TableCell>
      <TableCell>{payeer}</TableCell>
      <TableCell>{type}</TableCell>
      <TableCell className="amount">{formattedAmount}</TableCell>
      <TableCell>{paymentMethod}</TableCell>
      <TableCell align="center">
        {isCollapsed ? (
          <ArrowDown onClick={() => setCollapsedRow(-1)} />
        ) : (
          <ArrowUp onClick={() => setCollapsedRow(index)} />
        )}
      </TableCell>
    </TableRow>
  );
};
